import { checkDefined } from 'faro-common-model';
export function toTenantOidc(tenantOidc) {
    checkDefined(tenantOidc.authority, 'TenantOidc', 'authority');
    checkDefined(tenantOidc.clientId, 'TenantOidc', 'clientId');
    checkDefined(tenantOidc.redirectUri, 'TenantOidc', 'redirectUri');
    checkDefined(tenantOidc.scope, 'TenantOidc', 'scope');
    return {
        authority: tenantOidc.authority,
        clientId: tenantOidc.clientId,
        redirectUri: tenantOidc.redirectUri,
        scope: tenantOidc.scope,
    };
}
//# sourceMappingURL=tenant-oidc.js.map